import {
  ICON_ADELL_LOGO,
  ICON_AMUSNET_LOGO,
  ICON_APOLLO_LOGO,
  ICON_EGAMING_LOGO,
  ICON_EGT_DIGITAL_LOGO,
  ICON_KAJOT_LOGO,
  ICON_PRAGMATIC_LOGO,
  ICON_SYNOT_LOGO,
  ICON_TECH4BET_LOGO,
} from '../../../../../IconLink/constants'

export const providersIcons = [
  {
    icon: ICON_EGAMING_LOGO,
    value: 'egaming.capi',
  },
  {
    icon: ICON_APOLLO_LOGO,
    value: 'apollo',
  },

  {
    icon: ICON_KAJOT_LOGO,
    value: 'kajot',
  },
  {
    icon: ICON_PRAGMATIC_LOGO,
    value: 'pragmatic',
  },
  {
    icon: ICON_SYNOT_LOGO,
    value: 'synot',
  },
  {
    icon: ICON_AMUSNET_LOGO,
    value: 'amusnet',
  },
  {
    icon: ICON_EGT_DIGITAL_LOGO,
    value: 'egt_digital',
  },
  {
    icon: ICON_ADELL_LOGO,
    value: 'adell',
  },
  {
    icon: ICON_TECH4BET_LOGO,
    value: 'tech4bet',
  },
]
